import script from "./v-col.vue?vue&type=script&lang=js"
export * from "./v-col.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__